export default __webpack_public_path__ + "static/icon-29-1-2f744313a3469348817d95065f90bf7b.png";